const { getElement, parseInteger } = window.BAO.Utils
class WishlistListPagination extends window.BAO.CustomElement() {
  static pagesToLoad = 10
  static pagesLoaded = 1
  static canAutoLoad = true
  static isAutoLoading = false

  connectedCallback () {
    super.connectedCallback()

    this.currentPage = parseInt(this.dataset.currentPage)

    this.loading = false

    if (this.totalItems !== this.currentItems) {
      this.classList.add(this.paginationEnabledClass)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onLoadButtonClick = this.onLoadButtonClick.bind(this)
    this.els.button.element.addEventListener('click', this.onLoadButtonClick)

    this.handleScroll = this.handleScroll.bind(this)
    this.listeners.add(document, 'scroll', this.handleScroll)
  }

  handleScroll () {
    if (this.constructor.isAutoLoading || !this.constructor.canAutoLoad) return

    const loadMoreEl = getElement(
      `.${this.paginationEnabledClass} ${this.els.button.selector}`,
      {
        context: document,
      },
    )

    if (!loadMoreEl) {
      this.constructor.isAutoLoading = false
      return
    }

    const autoLoadLimitReached =
      parseInteger(this.constructor.pagesToLoad) ===
      parseInteger(this.constructor.pagesLoaded)

    if (autoLoadLimitReached) {
      this.constructor.canAutoLoad = false
      this.constructor.pagesLoaded = 1
      return
    }

    if (!autoLoadLimitReached) {
      this.constructor.isAutoLoading = true
      this.constructor.pagesLoaded = this.constructor.pagesLoaded + 1
      loadMoreEl.click()
    }

    setTimeout(() => {
      this.constructor.isAutoLoading = false
    }, 500)
  }

  async onLoadButtonClick (e) {
    if (this.loading) return
    this.loading = true

    this.currentPage += 1
    const htmlContent = await fetch(
      `${window.theme.appSettings.proxyUrl}/lists/${this.listId}/page/${
        this.currentPage
      }${this.paginationSearchParam()}`,
    ).then(r => {
      if (!r.ok) throw r
      return r.text()
    })

    this.externalEls.container.element.innerHTML += htmlContent

    let newCount = this.currentPage * this.perPage
    if (newCount > this.totalItems) newCount = this.totalItems

    const percentage = Math.ceil((100 / this.totalItems) * newCount)

    if (this.totalItems === newCount) {
      this.classList.remove('wlt-Pagination-enabled')
    }

    this.els.text.element.innerHTML = this.textTemplate
      .replace('{count}', newCount)
      .replace('{total}', this.totalItems)

    this.setPageSearchParam(this.currentPage)
    this.setBarPercentage(percentage)

    this.loading = false
  }

  setPageSearchParam (page) {
    const params = this.searchParams
    params.page = page
    const paramsString = new URLSearchParams(params).toString()
    const newUrl = `${location.protocol}//${location.host}${location.pathname}${
      paramsString ? '?' : ''
    }${paramsString}`
    window.history.pushState({ path: newUrl }, '', newUrl)
  }

  setBarPercentage (percent) {
    this.style.setProperty('--Bar_Percentage', `${percent}%`)
  }

  paginationSearchParam () {
    const params = this.searchParams
    const newParams = {}
    if (params?.sort) newParams.sort = params?.sort
    if (params?.term) newParams.term = params?.term

    const searchParamsString = new URLSearchParams(newParams).toString()

    return searchParamsString !== '' ? `?${searchParamsString}` : ''
  }

  get paginationEnabledClass () {
    return 'wlt-Pagination-enabled'
  }

  get searchParams () {
    const urlSearchParams = new URLSearchParams(window.location.search)
    return Object.fromEntries(urlSearchParams.entries())
  }

  get listId () {
    return this.dataset.listId
  }

  get perPage () {
    return parseInt(this.dataset.perPage)
  }

  get currentItems () {
    return parseInt(this.dataset.currentItems)
  }

  get totalItems () {
    return parseInt(this.dataset.totalItems)
  }

  get textTemplate () {
    return this.dataset.textTemplate
  }
}

customElements.define('wishlist-list-pagination', WishlistListPagination)
